import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "content" }
const _hoisted_2 = ["disabled"]

import { ElDialog } from "element-plus";
import { nextTick, ref, watch } from "vue";

export default /*#__PURE__*/_defineComponent({
  props: {
  header: {
    type: String,
    required: true,
  },
  content: {
    type: String,
    required: true,
  },
  visible: {
    type: Boolean,
    required: true,
  },
  submitDisabled: {
    type: Boolean,
    default: false,
  },
},
  emits: ["cancel", "submit", "visibleChange"],
  setup(__props, { emit: emits }) {

const props = __props





const modalValue = ref(props.visible);
watch(
  () => props.visible,
  (newVal: boolean) => {
    modalValue.value = newVal;
    nextTick(() => {
      emits("visibleChange", newVal);
    });
  }
);

const cancel = () => {
  emits("cancel");
};
const submit = () => {
  if (props.submitDisabled) {
    return;
  }
  emits("submit");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ElDialog), {
    "custom-class": "music-exam-confirm-dialog",
    modelValue: modalValue.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modalValue).value = $event)),
    "show-close": false,
    "append-to-body": true,
    "close-on-click-modal": false
  }, {
    default: _withCtx(() => [
      _createElementVNode("header", null, _toDisplayString(__props.header), 1),
      _createElementVNode("p", _hoisted_1, _toDisplayString(__props.content), 1),
      _createElementVNode("footer", null, [
        _createElementVNode("button", {
          class: "base-btn cancel",
          onClick: cancel
        }, "取 消"),
        _createElementVNode("button", {
          class: _normalizeClass(["base-btn submit", __props.submitDisabled ? 'base-btn_diabled' : '']),
          onClick: submit,
          disabled: __props.submitDisabled
        }, " 确 定 ", 10, _hoisted_2)
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})